// extracted by mini-css-extract-plugin
export var dropdown = "_s4-0";
export var imageWrapper = "_s4-3";
export var itemNameContainer = "_s4-1";
export var productImage = "_s4-2";
export var spinnerWrapper = "_s4-4";